import { Navigate, Route, Routes } from 'react-router-dom';
import AppShell from './components/AppShell.js';
import RequireSession from './components/RequireSession.js';
import AlertsPage from './pages/AlertsPage.js';
import ConfirmPage from './pages/ConfirmPage.js';
import HistoryPage from './pages/HistoryPage.js';
import MenuPage from './pages/MenuPage.js';
import BatchPage from './pages/BatchPage.js';
import NotFoundPage from './pages/NotFoundPage.js';
import ProfilePage from './pages/ProfilePage.js';
import OrderPage from './pages/OrderPage.js';
import SignInPage from './pages/SignInPage.js';
import PasswordPage from './pages/PasswordPage.js';
import SetPasswordPage from './pages/SetPasswordPage.js';
import ChangePasswordPage from './pages/ChangePasswordPage.js';
import HomePage from './pages/HomePage.js';
import JoinPage from './pages/JoinPage.js';

export default function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/password" element={<PasswordPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      {/* The company link. Open whether or not somebody is signed in: a
          phone that belongs to one person can still be handed to another. */}
      <Route path="/join/:code" element={<JoinPage />} />

      <Route
        element={
          <RequireSession>
            <AppShell>
            <Routes>
              <Route index element={<HomePage />} />
              <Route path="menu" element={<MenuPage />} />
              <Route path="book" element={<BatchPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="alerts" element={<AlertsPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="order/:serviceDate/:mealType/:menuItemId" element={<OrderPage />} />
              <Route path="confirm/:orderId" element={<ConfirmPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            </AppShell>
          </RequireSession>
        }
        path="/*"
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
